<template>
<ItpPage
  :size="size"
  :header="documentTitle"
  :loaded="loaded"
  :noShow="!loaded"
  :modal="modal"
  itp-cname="Templates"
  :modalBindings="b_7315092382398562_modalBindings"
  @close="evh_7315092382398562_close($event, {})"
>
  <UcHeader
    :card="!modal"
    :modal="modal"
    :title="documentTitle"
    slot="header"
    v-if="loaded"
    @close="evh_2248226175642056_close($event, {})"
  >
    <ItpBox>
      <UcTemplateSelector
        @optionSelected="evh_6466705138206980_optionSelected($event, {})"
      >
      </UcTemplateSelector>
      <ItpButton
        variant="default"
        icon="fa-sync-alt"
        :text="'Reload'|gettext"
        :spinning="actions.reload.isRunning"
        class="mx-3"
        @click.prevent.stop="evh_8320016629450276_clickPreventStop($event, {})"
      >
      </ItpButton>
      <vr>
      </vr>
      <ItpButton
        :form="formId"
        :text="'Save'|pgettext('Templates')"
        type="submit"
        variant="primary"
        default
        :spinning="actions.save.isRunning"
      >
      </ItpButton>
      <ItpButton
        icon="fa-file-invoice"
        :text="'Preview'|pgettext('Templates')"
        variant="primary"
        :disabled="!item || !sampleData"
        class="ml-3"
        @click.prevent.stop="evh_8116269939469002_clickPreventStop($event, {})"
      >
      </ItpButton>
      <ItpButton
        icon="fa-file-invoice"
        :text="'Export'|pgettext('Templates')"
        variant="light"
        :disabled="!item"
        use-auth
        force-download
        downloadFileName="templates.yaml"
        :href="$fn.urlFor('read_template', {id: 'export'})"
        class="ml-3"
      >
      </ItpButton>
      <ItpButton
        icon="fa-file-invoice"
        :text="'Import'|pgettext('Templates')"
        variant="light"
        class="ml-3"
        @click.prevent.stop="evh_1655522927138420_clickPreventStop($event, {})"
      >
      </ItpButton>
    </ItpBox>
  </UcHeader>
  <UcBody
    :card="!modal"
    :modal="modal"
    v-if="loaded"
  >
    <ItpForm
      :id="formId"
      :name="formName"
      @submit="evh_1040167445267876_submit($event, {})"
    >
      <UcTemplate
        :item="editor"
        :context="contextData"
        v-if="editor"
      >
      </UcTemplate>
    </ItpForm>
  </UcBody>
  <template
    slot="footer"
    v-if="loaded"
  >
  </template>
</ItpPage>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

addRoute(
  {
    name: "templates",
    path: "/templates",
    component: "Templates"
  }
)

addRoute(
  {
    name: "templates.template",
    path: ":id",
    component: "Template",
    params: [{
      name: "id",
      prop: "resourceId",
    }
      ,
    ]

  }
)

@Component()
export default class Templates extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "page",
  };

  beforeCreate() {
    this.$$cache_contextData = new ComponentValueCache(this, "contextData", "Template.sampleData");
  }

  onOptionSelected(...args: any[]) {
    const [option] = args;
    this.$router.replace({
      name: 'app.templates.template',
      params: { id: option.id }
    })
  }

  getSelectedItemId(...args: any[]) {
    if (this.$route.params && this.$route.params.id) {
      return this.$route.params.id;
    }
  }

  @Prop({
    type: String,
    default: "md",
  })
  size!: string;

  @Watch('size')
  onSize(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("size")
  }

  formId!: any;

  async $$load_formId() {
    return this.$fn.randomElementId()
  }

  formName!: any;
  items!: any;

  async $$load_items() {
    return this.$fn.fetch('list_template').then(d => _.sortBy(d, 'created_at'))
  }

  oid!: any;

  async $$load_oid() {
    return this.getSelectedItemId()
  }

  optionTemplate!: any;
  selectedValueInternal!: any;

  async $$load_selectedValueInternal() {
    return this.selectedValue
  }

  item!: any;

  async $$load_item() {
    return this.oid
      ? this.$fn.fetch('read_template', { asResource: true, parameters: { id: this.oid } })
      : null
  }

  editor!: any;

  async $$load_editor() {
    return this.item ? this.item.editor() : null
  }

  contextData!: any;

  async $$load_contextData() {
    return { sampleData: null }
  }

  ux!: any;
  b_7315092382398562_modalBindings!: any;
  dataMembers = ['formId', 'formName', 'items', 'oid', 'optionTemplate', 'selectedValueInternal', 'item', 'editor', 'contextData', 'ux', 'b_7315092382398562_modalBindings'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        formId: null,
        formName: "template",
        items: null,
        oid: null,
        optionTemplate: "<div>\n\
  {{ option.name }}\n\
  ({{ option.object_type }})\n\
</div>\n\
",
        selectedValueInternal: null,
        item: null,
        editor: null,
        contextData: null,
        ux: null,
        b_7315092382398562_modalBindings: {
          size: "sm",
        }
        ,
      },
    }
  }

  get sampleData() {
    if (this.loaded) {

      return this.contextData.sampleData
    }
    return null;
  }

  get document() {
    if (this.loaded) {

      return {
        title: this.$fn.pgettext("Templates", "Templates"),
      }
    }
    return null;
  }

  async act_7315092382398562_closeModal_5800_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseModalActionArgs> {
    // parameterResolver name=act_7315092382398562_closeModal_5800, alias=undefined
    return {
      name: this.modalName,
      result: {
        close: true,
        cancel: true,
      }
      ,
    }
  }

  async evh_7315092382398562_close(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
  }

  async evh_2248226175642056_close(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_2248226175642056_close.executeFromDOM(this, event, scope);
  }

  async act_6466705138206980_script_5804_getActionArgs_value($event: actions.ActionEvent) {
    // callableMethod act_6466705138206980_script_5804, alias=undefined
    this.onOptionSelected($event.data.option)
  }

  async act_6466705138206980_script_5804_getActionArgs($event: actions.ActionEvent): Promise<actions.ScriptActionArgs> {
    // parameterResolver name=act_6466705138206980_script_5804, alias=undefined
    return {
      value: () => this.act_6466705138206980_script_5804_getActionArgs_value($event),
    }
  }

  async evh_6466705138206980_optionSelected(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_6466705138206980_optionSelected.executeFromDOM(this, event, scope);
  }

  async evh_8320016629450276_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_8320016629450276_clickPreventStop.executeFromDOM(this, event, scope);
  }

  async act_8116269939469002_showModal_5808_getActionArgs($event: actions.ActionEvent): Promise<actions.ShowModalActionArgs> {
    // parameterResolver name=act_8116269939469002_showModal_5808, alias=undefined
    return {
      name: "TemplatePreview",
      props: {
        item: this.item,
        sampleData: this.contextData.sampleData,
      }
      ,
    }
  }

  async evh_8116269939469002_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_8116269939469002_clickPreventStop.executeFromDOM(this, event, scope);
  }

  async act_1655522927138420_showModal_5810_getActionArgs($event: actions.ActionEvent): Promise<actions.ShowModalActionArgs> {
    // parameterResolver name=act_1655522927138420_showModal_5810, alias=undefined
    return {
      name: "FileSelector",
      props: {
        url: this.$fn.urlFor('read_template', { id: 'import' }),
        accept: ".yaml",
      }
      ,
    }
  }

  async evh_1655522927138420_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_1655522927138420_clickPreventStop.executeFromDOM(this, event, scope);
  }

  async act_1040167445267876_setData_5814_getActionArgs($event: actions.ActionEvent): Promise<actions.SetDataActionArgs> {
    // parameterResolver name=act_1040167445267876_setData_5814, alias=undefined
    return {
      path: "item",
      value: $event.data.response.data,
      resolve: false,
      noTouchLastLoaded: false,
      noTakeSnapshot: false,
    }
  }

  async evh_1040167445267876_success_5813_getWhen($event: actions.ActionEvent): Promise<actions.EventHandlerImplArgs> {
    // parameterResolver name=evh_1040167445267876_success_5813, alias=undefined
    return $event.data.response.data
  }

  async act_1040167445267876_rest_5812_getActionArgs($event: actions.ActionEvent): Promise<actions.RestActionArgs> {
    // parameterResolver name=act_1040167445267876_rest_5812, alias=save
    return {
      method: "save",
      container: {
        self: this.item.links.parent,
        object: 'list',
        data: []
      },
      resource: this.editor,
    }
  }

  async evh_1040167445267876_submit(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_1040167445267876_submit.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_7315092382398562_closeModal_5800: actions.CloseModalAction;
    evh_7315092382398562_close_5799: actions.EventHandlerImpl;
    evh_7315092382398562_close: actions.EventHandlerGroup;
    act_2248226175642056_closeModal_5802: actions.CloseModalAction;
    evh_2248226175642056_close_5801: actions.EventHandlerImpl;
    evh_2248226175642056_close: actions.EventHandlerGroup;
    act_6466705138206980_script_5804: actions.ScriptAction;
    evh_6466705138206980_optionSelected_5803: actions.EventHandlerImpl;
    evh_6466705138206980_optionSelected: actions.EventHandlerGroup;
    act_8320016629450276_reloadComponentData_5806: actions.ReloadComponentDataAction;
    evh_8320016629450276_clickPreventStop_5805: actions.EventHandlerImpl;
    evh_8320016629450276_clickPreventStop: actions.EventHandlerGroup;
    act_8116269939469002_showModal_5808: actions.ShowModalAction;
    evh_8116269939469002_clickPreventStop_5807: actions.EventHandlerImpl;
    evh_8116269939469002_clickPreventStop: actions.EventHandlerGroup;
    act_1655522927138420_showModal_5810: actions.ShowModalAction;
    evh_1655522927138420_clickPreventStop_5809: actions.EventHandlerImpl;
    evh_1655522927138420_clickPreventStop: actions.EventHandlerGroup;
    act_1040167445267876_setData_5814: actions.SetDataAction;
    evh_1040167445267876_success_5813: actions.EventHandlerImpl;
    act_1040167445267876_rest_5812: actions.RestAction;
    evh_1040167445267876_submit_5811: actions.EventHandlerImpl;
    evh_1040167445267876_submit: actions.EventHandlerGroup;
  }

  getActions() {
    const act_7315092382398562_closeModal_5800 = new actions.CloseModalAction(
      {
        actionArgs: this.act_7315092382398562_closeModal_5800_getActionArgs,
        events: [],
      }
    );
    const evh_7315092382398562_close_5799 = new actions.EventHandlerImpl(
      {
        action: act_7315092382398562_closeModal_5800,
        event: "close",
        displayName: "closeModal",
      }
    );
    const evh_7315092382398562_close = new actions.EventHandlerGroup(
      {
        handlers: [evh_7315092382398562_close_5799],
      }
    );
    const act_2248226175642056_closeModal_5802 = new actions.CloseModalAction(
      {
        events: [],
      }
    );
    const evh_2248226175642056_close_5801 = new actions.EventHandlerImpl(
      {
        action: act_2248226175642056_closeModal_5802,
        event: "close",
        displayName: "closeModal",
      }
    );
    const evh_2248226175642056_close = new actions.EventHandlerGroup(
      {
        handlers: [evh_2248226175642056_close_5801],
      }
    );
    const act_6466705138206980_script_5804 = new actions.ScriptAction(
      {
        actionArgs: this.act_6466705138206980_script_5804_getActionArgs,
        events: [],
      }
    );
    const evh_6466705138206980_optionSelected_5803 = new actions.EventHandlerImpl(
      {
        action: act_6466705138206980_script_5804,
        event: "optionSelected",
        displayName: "script",
      }
    );
    const evh_6466705138206980_optionSelected = new actions.EventHandlerGroup(
      {
        handlers: [evh_6466705138206980_optionSelected_5803],
      }
    );
    const act_8320016629450276_reloadComponentData_5806 = new actions.ReloadComponentDataAction(
      {
        displayName: "reload",
        events: [],
      }
    );
    const evh_8320016629450276_clickPreventStop_5805 = new actions.EventHandlerImpl(
      {
        action: act_8320016629450276_reloadComponentData_5806,
        event: "click.prevent.stop",
        displayName: "reload",
      }
    );
    const evh_8320016629450276_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_8320016629450276_clickPreventStop_5805],
      }
    );
    const act_8116269939469002_showModal_5808 = new actions.ShowModalAction(
      {
        actionArgs: this.act_8116269939469002_showModal_5808_getActionArgs,
        events: [],
      }
    );
    const evh_8116269939469002_clickPreventStop_5807 = new actions.EventHandlerImpl(
      {
        action: act_8116269939469002_showModal_5808,
        event: "click.prevent.stop",
        displayName: "showModal",
      }
    );
    const evh_8116269939469002_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_8116269939469002_clickPreventStop_5807],
      }
    );
    const act_1655522927138420_showModal_5810 = new actions.ShowModalAction(
      {
        actionArgs: this.act_1655522927138420_showModal_5810_getActionArgs,
        events: [],
      }
    );
    const evh_1655522927138420_clickPreventStop_5809 = new actions.EventHandlerImpl(
      {
        action: act_1655522927138420_showModal_5810,
        event: "click.prevent.stop",
        displayName: "showModal",
      }
    );
    const evh_1655522927138420_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_1655522927138420_clickPreventStop_5809],
      }
    );
    const act_1040167445267876_setData_5814 = new actions.SetDataAction(
      {
        actionArgs: this.act_1040167445267876_setData_5814_getActionArgs,
        events: [],
      }
    );
    const evh_1040167445267876_success_5813 = new actions.EventHandlerImpl(
      {
        action: act_1040167445267876_setData_5814,
        event: "success",
        when: this.evh_1040167445267876_success_5813_getWhen,
        displayName: "setData",
      }
    );
    const act_1040167445267876_rest_5812 = new actions.RestAction(
      {
        actionArgs: this.act_1040167445267876_rest_5812_getActionArgs,
        displayName: "save",
        events: [evh_1040167445267876_success_5813],
      }
    );
    const evh_1040167445267876_submit_5811 = new actions.EventHandlerImpl(
      {
        action: act_1040167445267876_rest_5812,
        event: "submit",
        displayName: "save",
      }
    );
    const evh_1040167445267876_submit = new actions.EventHandlerGroup(
      {
        handlers: [evh_1040167445267876_submit_5811],
      }
    );
    return {
      act_7315092382398562_closeModal_5800,
      evh_7315092382398562_close_5799,
      evh_7315092382398562_close,
      act_2248226175642056_closeModal_5802,
      evh_2248226175642056_close_5801,
      evh_2248226175642056_close,
      act_6466705138206980_script_5804,
      evh_6466705138206980_optionSelected_5803,
      evh_6466705138206980_optionSelected,
      act_8320016629450276_reloadComponentData_5806,
      evh_8320016629450276_clickPreventStop_5805,
      evh_8320016629450276_clickPreventStop,
      act_8116269939469002_showModal_5808,
      evh_8116269939469002_clickPreventStop_5807,
      evh_8116269939469002_clickPreventStop,
      act_1655522927138420_showModal_5810,
      evh_1655522927138420_clickPreventStop_5809,
      evh_1655522927138420_clickPreventStop,
      act_1040167445267876_setData_5814,
      evh_1040167445267876_success_5813,
      act_1040167445267876_rest_5812,
      evh_1040167445267876_submit_5811,
      evh_1040167445267876_submit,
      reload: act_8320016629450276_reloadComponentData_5806,
      save: act_1040167445267876_rest_5812,
    }
  }
}

Vue.component("Templates", Templates);

</script>